import styled from 'styled-components'
import { Container } from '../layout/container'

export const StyledContentHeader = styled(Container)`
  padding-bottom: 40px;
  height: 192px;
  margin-top: 0;
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  background-color: var(--tds-blue-800);
  font-family: 'Scania Sans', Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 32px;
  line-height: 32px;
  letter-spacing: -0.04em;
`

export const Title = styled.div`
  color: var(--tds-grey-500);
  margin-bottom: 8px;
`

export const Subtitle = styled.div`
  color: white;
`
